import React from 'react';
import './profile.css';
import { FaLinkedin, FaGithub, FaTwitter } from 'react-icons/fa';
import ProfilePhoto from '../../assests/akramimage.jpeg'; 
import { useNavigate } from 'react-router-dom';
import ThreeScene from './threescene';
import CanvasComponent from './canvascomponent';
import ThreeScene1 from './threejs';


function Profile() {

  const navigate = useNavigate();

  const handleAboutClick = () => {
    navigate('/about');
  };

  return (<div>
     
 <ThreeScene/>
 
 
    <div className="profile-container " >
   
    <div className="profile-photo-frame starburst-shape" >
  < img src={ProfilePhoto} alt="Akram" />
  
  
</div>





      
       


      <div className="profile-info">
      
        <h1 className='text'>Welcome, I'm Akram</h1>

        <p>
          As a passionate full-stack developer, I specialize in crafting elegant, modern web and mobile applications that turn innovative ideas into tangible, user-friendly products. Let's collaborate and bring your vision to life!
        </p>
        <div className="social-links">
          <a href="https://linkedin.com/in/akram-faridi-b83781225" target="_blank" rel="noreferrer">
            <FaLinkedin />
          </a>
          <a href="https://github.com/codewithAkram-ui" target="_blank" rel="noreferrer">
            <FaGithub />
          </a>
          <a href="https://x.com/akram__official?t=e9oPRDrFFtJWV_UZxthCHw&s=08" target="_blank" rel="noreferrer">
            <FaTwitter />
          </a>
         
        </div>
        <button className="learn-more" onClick={handleAboutClick}>About Me</button>
      </div>
  
      
    </div>
    
    <CanvasComponent/>
        <div className="profile-blog">
        <h2>From Full-Stack Development to Machine Learning: My Journey in the World of Tech</h2>
        <p>
          As a full-stack developer, my journey has been an exciting mix of front-end design, back-end architecture, and the transformative power of machine learning. Throughout my career, I've worked on numerous projects, each of which has allowed me to hone my skills in various technologies, including Python, Flask, ReactJS, React Native, and many others. But what truly excites me is the intersection of full-stack development and machine learning—where creativity meets innovation to solve real-world problems.
        </p>
        <h3>The Full-Stack Foundation</h3>
        <p>
          My foundation as a full-stack developer has given me a comprehensive understanding of both front-end and back-end technologies. I enjoy the creative process of designing intuitive user interfaces with ReactJS and React Native, ensuring that the user experience is seamless and engaging. At the same time, I take pride in building robust and scalable back-end systems using Flask, Python, and other tools. Whether it's managing databases, setting up APIs, or ensuring security, I find satisfaction in creating systems that work efficiently and effectively.
        </p>
        <h3>Diving into Machine Learning</h3>
        <p>
          Machine learning (ML) has been a game-changer in the tech world, and for me, it has opened up new avenues to explore. From predictive analytics to intelligent automation, ML enables us to build systems that learn and adapt. My journey into machine learning started with Python, a language that has become synonymous with data science. I quickly realized the potential of ML in solving complex problems, and I began integrating it into my projects.
        </p>
        <p>
          One of the most rewarding aspects of machine learning is its ability to process vast amounts of data and extract meaningful insights. Whether it's building recommendation systems, image recognition models, or natural language processing (NLP) applications, I love the challenge of transforming data into actionable results. The combination of my full-stack skills and machine learning expertise allows me to build end-to-end solutions—from data collection and processing to model deployment and integration into web or mobile applications.
        </p>
        <h3>Bringing It All Together: Real-World Applications</h3>
        <p>
          What excites me most is the ability to bring all these skills together to create real-world applications that make a difference. For instance, I've worked on projects where I combined machine learning models with ReactJS to build interactive dashboards that provide real-time insights. In other cases, I've developed mobile apps using React Native that leverage machine learning for features like voice recognition or personalized content recommendations.
        </p>
        <p>
          One of the key challenges in integrating machine learning into full-stack applications is ensuring that the models are both accurate and efficient. This involves careful selection of algorithms, optimization techniques, and deployment strategies. But it's a challenge I gladly accept because the results are truly impactful.
        </p>
        <h3>Staying Ahead of the Curve</h3>
        <p>
          The tech landscape is ever-evolving, and staying ahead of the curve is essential. I continually invest time in learning new technologies and improving my existing skills. Whether it's experimenting with the latest libraries in Python, exploring new features in ReactJS, or diving deeper into advanced machine learning techniques, I'm always eager to expand my knowledge.
        </p>
        <p>
          I also enjoy sharing my knowledge with others, whether it's through writing blogs, contributing to open-source projects, or collaborating with fellow developers. I believe that the tech community thrives on collaboration.
        </p>
      </div>
      
      </div>
  );
}

export default Profile;
